import { Box } from '@mui/material';
import NewsAndChangelog from '../../Changelogs/NewsAndChangelog';
import DashboardWidgetCard from '../DashboardWidgetCard';

// News-only widget (separate from the changelog/software-updates feed), visible
// to every user. Reuses the shared feed component in 'news' mode.
export default function NewsWidget({ widget, editMode, onHide, dragHandleProps }) {
  return (
    <DashboardWidgetCard
      title={widget.title}
      icon={widget.icon}
      accent={widget.accent}
      editMode={editMode}
      onHide={onHide}
      dragHandleProps={dragHandleProps}
    >
      <Box sx={{ maxHeight: { xs: 360, sm: 420 }, overflowY: 'auto', mx: -0.5, px: 0.5 }}>
        <NewsAndChangelog mode='news' />
      </Box>
    </DashboardWidgetCard>
  );
}
